import mobile from './mobile';
import mobileDetail from './mobileDetail';
import pc from './pc';
import pcDetail from './pcDetail';
import console from './console';
import consoleDetail from './consoleDetail';
import pcAndConsole from './pc&console';
import pcAndConsoleDetail from './pc&consoleDetail';
import companies from './companies';
import companiesDetail from './companiesDetail';
import storeRank from './StoreRank';
import marketProfile from './marketProfile';
import genreProfile from './genreProfile';
import globalView from './globlView';
import benchmark from './benchmark';
import overlap from './overlap';
import streaming from './streaming';
import following from './following';
import compare from './compare';

export default {
  ...mobile,
  ...mobileDetail,
  ...pc,
  ...pcDetail,
  ...console,
  ...consoleDetail,
  ...pcAndConsole,
  ...pcAndConsoleDetail,
  ...companies,
  ...companiesDetail,
  ...storeRank,
  ...marketProfile,
  ...genreProfile,
  ...globalView,
  ...benchmark,
  ...overlap,
  ...streaming,
  ...following,
  ...compare,
};
